let
steps,
count = -1;

const
get = function(selector) {
	return document.querySelector(selector);
},
templates = {
	intro: '<div class="{type}">\
		<div class="{type}-left" style="background-image:url({img});">\
		</div>\
		<div class="{type}-right">\
			<div class="{type}-heading">{heading}</div>\
			<div class="{type}-body">{body}</div>\
			<button class=\"start\" data-step="{yes}">START</button>\
		</div>\
	</div>',
	question: '<div class="{type}">\
		<div class="{type}-left" style="background-image:url({img});">\
			<div class="{type}-count">{count}</div>\
		</div>\
		<div class="{type}-right">\
			<div class="{type}-heading">{heading}</div>\
			<div class="{type}-body">{body}</div>\
			<div class="{type}-answers">\
				<button data-step="{yes}">YES</button>\
				<button data-step="{no}">NO</button>\
			</div>\
		</div>\
	</div>',
	outcome: '<div class="{type}">\
		<div class="{type}-left" style="background-image:url({img});">\
		</div>\
		<div class="{type}-right">\
			<div class="{type}-heading">{heading}</div>\
			<div class="{type}-body">{body}</div>\
			<div class="{type}-foot">\
				<a href=\"#\" class="core-button button-blue button-outline restart">Restart quiz</a>\
			</div>\
		</div>\
	</div>',
	result: '<div class="{type}">\
		<div class="{type}-heading">{heading}</div>\
		<div class="{type}-left">\
			<div class="{type}-img" style="background-image:url({img});" /></div>\
		</div>\
		<div class="{type}-right">\
			<div class="{type}-body">{body}</div>\
			<div class="{type}-more">\
				<a href="{cta-href}">{cta-text}</a>\
			</div>\
			<div class="{type}-foot">\
				<a href="/search-and-apply/?discipline=Apprentices" class="core-button button-purple button-outline">View all our apprenticeships</a>\
			</div>\
			<div class="{type}-foot bottom">\
				<a href=\"#\" class="link-arrow restart">Restart quiz</a>\
			</div>\
		</div>\
	</div>'
},
root = get('#quiz'),
renderStep = function(id) {

	var
	step = steps[id],
	template = templates[step.type];

	if(step.count) {
		count = step.count;
	}
	else {
		count ++;
	};

	template = replace(template, {
		count: ('Q' + count)
	});

	root.innerHTML = replace(template, step);

	if(step.yes&&steps[step.yes].img) {
		loadImage(steps[step.yes].img);
	};

	if(step.no&&steps[step.no].img) {
		loadImage(steps[step.no].img);
	};

},
replace = function(string, obj) {

	for(var prop in obj) {
		string = string.replace(new RegExp('{' + prop + '}', 'ig'), obj[prop]);
	};

	return string;

},
loadImage = function(src) {

	var
	img = new Image();

	img.src = src;

},
map = function(items, key) {

	var
	out = {};

	items.forEach(function(item) {

		out[item[key]] = item;

	});

	return out;

};


export default function() {
	return this.each(function() {

		$(this).delegate('[data-step]', 'click', function() {

			renderStep($(this).attr('data-step'));
			return false;

		}).delegate('.restart', 'click', function() {

			count = 0;
			renderStep(steps['INTRO'].yes);
			return false;

		});

		const quizJsonSteps = window.quiz_json && window.quiz_json.steps || [];
		steps = map(quizJsonSteps, 'id');
		renderStep('INTRO');
	});
};
